
(() => {
  const $ = (s, r=document) => r.querySelector(s);
  const $$ = (s, r=document) => [...r.querySelectorAll(s)];
  const saveData = !!(navigator.connection && navigator.connection.saveData);
  const mediaSrc = v => v && (v.dataset.src || v.getAttribute('src') || '');
  const loadVideo = v => {
    if(!v || v.getAttribute('src') || !v.dataset.src) return;
    v.setAttribute('src', v.dataset.src);
    v.load();
  };
  const unloadVideo = v => {
    if(!v || !v.getAttribute('src')) return;
    v.pause();
    try { v.currentTime=0; } catch(e){}
    v.removeAttribute('src');
    v.load();
  };
  const safePlay = (v, denied) => {
    if(!v) return Promise.resolve();
    loadVideo(v);
    const p=v.play();
    return p&&p.catch ? p.catch(err=>{ if(denied) denied(err); }) : Promise.resolve();
  };

  const SP={t:{play_clip:'Play clip'}};
  /* ---------- story steppers ----------
     Desktop: clip plays in the stage beside the list, auto-advances until someone taps.
     Phone: the clip moves inside the open step, one step open at a time, no auto-advance. */
  const stepMQ=matchMedia('(max-width: 899px)');
  const navH=()=>($('.nav')?.getBoundingClientRect().height||0);
  $$('[data-steps]').forEach(list => {
    const key=list.dataset.steps, stage=$(`.stage[data-stage="${key}"]`), home=stage.parentElement;
    const media=$$('[data-step]',stage), steps=$$('.step',list);
    let cur=steps.findIndex(st=>st.classList.contains('on')); if(cur<0) cur=0;
    let visible=false, picked=false;
    const bars=steps.map(st=>$('.st-bar b',st));
    /* tap-to-play */
    const auto = stage.dataset.autoplay==='true';
    const pbtn=document.createElement('button'); pbtn.type='button'; pbtn.className='sp-play'; pbtn.setAttribute('aria-label', (SP.t&&SP.t.play_clip)||'Play clip');
    pbtn.innerHTML='<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M8 5.5v13l11-6.5z" fill="currentColor"/></svg>'; stage.appendChild(pbtn);
    const playIcon='<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M8 5.5v13l11-6.5z" fill="currentColor"/></svg>';
    const pauseIcon='<svg viewBox="0 0 24 24" aria-hidden="true"><rect x="6" y="5" width="4" height="14" rx="1" fill="currentColor"/><rect x="14" y="5" width="4" height="14" rx="1" fill="currentColor"/></svg>';
    const showPlay=paused=>{ const m=media[cur], hasVideo=m&&m.tagName==='VIDEO'; pbtn.hidden=!hasVideo; pbtn.classList.toggle('is-playing',hasVideo&&!paused); pbtn.innerHTML=paused?playIcon:pauseIcon; pbtn.setAttribute('aria-label',paused?((SP.t&&SP.t.play_clip)||'Play clip'):'Pause clip'); stage.classList.toggle('sp-paused',!!paused); };
    const primeWindow=i=>media.forEach((m,j)=>{ if(m.tagName!=='VIDEO') return; if(j===i || (!saveData&&j===i+1)) loadVideo(m); else unloadVideo(m); });
    pbtn.addEventListener('click',e=>{ e.stopPropagation(); const m=media[cur]; if(!m||m.tagName!=='VIDEO') return; picked=true; if(m.paused){ safePlay(m,()=>showPlay(true)); } else m.pause(); });
    const setBar=(i,f)=>bars.forEach((b,j)=>b.style.width = j===i ? (f*100).toFixed(1)+'%' : '0%');
    function place(){
      const slot = stepMQ.matches ? $('.st-media',steps[cur]) : home;
      if(stage.parentElement!==slot) slot.appendChild(stage);
    }
    function run(){
      const m=media[cur];
      /* Keep the manual play control in sync as soon as a frame is selected.
         The stage can be re-parented on mobile/desktop before IntersectionObserver
         reports it visible; waiting for that callback left a valid video looking
         like an unplayable poster. */
      if(!auto) showPlay(m.tagName==='VIDEO' && m.paused);
      if(!visible) return;
      primeWindow(cur);
      if(!auto){ if(m.tagName!=='VIDEO') setBar(cur,0); return; }
      if(m.tagName==='VIDEO'){ m.currentTime=0; safePlay(m,()=>showPlay(true)); }
      else { const t0=performance.now(), hold=5000; const tick=now=>{ if(media[cur]!==m||!visible) return; const f=Math.min(1,(now-t0)/hold); setBar(cur,f); if(f<1) requestAnimationFrame(tick); else next(); }; requestAnimationFrame(tick); }
    }
    function next(){ if(picked || stepMQ.matches) run(); else go((cur+1)%media.length); }
    function go(i){
      media.forEach((m,j)=>{ m.classList.toggle('on',j===i); if(m.tagName==='VIDEO' && j!==i) m.pause(); });
      steps.forEach((st,j)=>{ st.classList.toggle('on',j===i); $('.st-h',st).setAttribute('aria-expanded', j===i); });
      cur=i; primeWindow(cur); place(); setBar(cur,0); run();
    }
    media.forEach((m,j)=>{ if(m.tagName!=='VIDEO') return;
      m.addEventListener('timeupdate',()=>{ if(j===cur && m.duration) setBar(j, m.currentTime/m.duration); });
      m.addEventListener('ended',()=>{ if(j!==cur) return; if(auto) next(); else { showPlay(true); setBar(j,1); } });
      m.addEventListener('play',()=>{ if(j===cur) showPlay(false); });
      m.addEventListener('pause',()=>{ if(j===cur && !m.ended) showPlay(true); });
      m.addEventListener('click',()=>{ if(j!==cur || auto) return; if(m.paused){ safePlay(m,()=>showPlay(true)); } else m.pause(); });
    });
    steps.forEach((st,j)=>$('.st-h',st).addEventListener('click',()=>{
      picked=true;
      if(j===cur && st.classList.contains('on')){ /* collapse the open step */
        st.classList.remove('on'); $('.st-h',st).setAttribute('aria-expanded','false');
        media.forEach(m=>{ if(m.tagName==='VIDEO') m.pause(); });
        if(stepMQ.matches && stage.parentElement!==home) home.appendChild(stage);
        return;
      }
      go(j);
      if(stepMQ.matches){
        requestAnimationFrame(()=>{ const top=st.getBoundingClientRect().top, nh=navH();
          if(top<nh+4 || top>innerHeight*0.45) window.scrollTo({top:scrollY+top-nh-12, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'}); });
      }
    }));
    new IntersectionObserver(([e])=>{ visible=e.isIntersecting; if(visible){ primeWindow(cur); run(); } else media.forEach(m=>m.tagName==='VIDEO'&&unloadVideo(m)); },{threshold:.05,rootMargin:'250px 0px'}).observe(stage);
    stepMQ.addEventListener('change',place);
    place();
  });

  /* ---------- face map ---------- */
  const zones=$$('.face-views .z'), zbtns=$$('.zone');
  function setZone(z){
    zones.forEach(p => { p.classList.toggle('on', p.dataset.zone===z); p.classList.toggle('dim', p.dataset.zone!==z); });
    zbtns.forEach(b => { const on=b.dataset.zone===z; b.classList.toggle('on',on); b.setAttribute('aria-pressed',on); });
  }
  const ZONE_SET={cheek:4,lip:3.5,neck:1.5};
  function pickZone(z){ setZone(z); const rr=$('#dialRange'); if(rr){ rr.value=ZONE_SET[z]; rr.dispatchEvent(new Event('input')); } }
  zones.forEach(p => { p.addEventListener('click', () => pickZone(p.dataset.zone)); p.addEventListener('keydown', e => { if(e.key==='Enter'||e.key===' '){ e.preventDefault(); pickZone(p.dataset.zone);} }); p.addEventListener('mouseenter', () => setZone(p.dataset.zone)); });
  zbtns.forEach(b => { b.addEventListener('click', () => pickZone(b.dataset.zone)); b.addEventListener('mouseenter', () => setZone(b.dataset.zone)); });
  setZone('cheek');



})();
